import { render } from "./SpinnerScreen.vue?vue&type=template&id=5dece935&scoped=true"
import script from "./SpinnerScreen.vue?vue&type=script&lang=js"
export * from "./SpinnerScreen.vue?vue&type=script&lang=js"

import "./SpinnerScreen.vue?vue&type=style&index=0&id=5dece935&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dece935"]])

export default __exports__